export default __webpack_public_path__ + "static/media/D041.89855eb9.jpg";